module.exports = __webpack_public_path__ + "static/img/1.11bbd6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel-1/1.jpg
// module id = tU9E
// module chunks = 1